import React from "react";
import { Link } from "react-router-dom";
import { Page } from "@/components/Layout";
import { ArrowRight, Buildings, GraduationCap, Briefcase } from "@phosphor-icons/react";

const paths = [
  { icon: Briefcase, title: "Corporate Wellness", division: "Couch", to: "/organisations/corporate" },
  { icon: GraduationCap, title: "School Workshops", division: "Couch", to: "/organisations/schools" },
  { icon: Buildings, title: "Psychology Career Workshops", division: "Forward", to: "/organisations/career-workshops" },
];

export default function Organisations() {
  return (
    <Page>
      <section className="md-section">
        <div className="md-container">
          <div className="md-label-eyebrow mb-4">For Organisations</div>
          <h1 className="text-5xl md:text-6xl font-serif mb-6">Programmes built for teams, schools and institutions</h1>
          <div className="grid md:grid-cols-3 gap-6 mt-12">
            {paths.map((p) => (
              <Link key={p.title} to={p.to} className="md-card md-card-hover" data-testid={`org-path-${p.title.toLowerCase().replace(/\s+/g, "-")}`}>
                <p.icon size={36} weight="duotone" style={{ color: "var(--md-primary)" }} />
                <div className="md-label-eyebrow mt-4">{p.division}</div>
                <h3 className="text-2xl font-serif mt-1">{p.title}</h3>
                <div className="mt-6 inline-flex items-center gap-1 text-sm font-medium" style={{ color: "var(--md-primary)" }}>Learn more <ArrowRight size={14} weight="bold" /></div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </Page>
  );
}
